import { Link } from 'react-router-dom';
import { FiClock, FiExternalLink, FiHelpCircle } from 'react-icons/fi';
import CopyButton from '../components/transaction/CopyButton';
import SponsoredSection from '../components/SponsoredSection';
import { useEvmBlock } from '../hooks/useEvmBlock';
import { formatRelativeTime, formatUtcTimestamp } from '../utils/formatTime';

function EvmBlockDetailsView({ number, chain = null }) {
  const { display, loading, error } = useEvmBlock(number, chain);

  if (loading) {
    return (
      <main className="sections eth-tx-page">
        <div className="stx-skeleton stx-skeleton-title" />
        <div className="stx-skeleton stx-skeleton-panel" />
      </main>
    );
  }

  if (error || !display) {
    return (
      <main className="sections eth-tx-page">
        <h1 className="eth-tx-page-title">Block Details</h1>
        <div className="stx-error">
          <p>{error || 'Block not found.'}</p>
          <Link to="/" className="eth-tx-link">Back to home</Link>
        </div>
      </main>
    );
  }

  return (
    <main className="sections eth-tx-page">
      <SponsoredSection />
      <h1 className="eth-tx-page-title">Block Details</h1>
      <p className="eth-tx-subtitle">{display.chainLabel} block {display.blockNumber}</p>

      <section className="eth-tx-card">
        <div className="eth-tx-row">
          <div className="eth-tx-row__label">
            <FiHelpCircle aria-hidden /> Block:
          </div>
          <div className="eth-tx-row__value">
            <span className="eth-tx-link eth-tx-link--bold">{display.blockNumber}</span>
            <CopyButton text={String(display.blockNumber)} className="eth-tx-copy" />
            {display.explorerBlockUrl ? (
              <a href={display.explorerBlockUrl} target="_blank" rel="noreferrer" className="eth-tx-link">
                Explorer <FiExternalLink aria-hidden />
              </a>
            ) : null}
          </div>
        </div>

        <div className="eth-tx-row">
          <div className="eth-tx-row__label">
            <FiHelpCircle aria-hidden /> Timestamp:
          </div>
          <div className="eth-tx-row__value eth-tx-inline">
            <FiClock aria-hidden />
            {formatRelativeTime(display.blockTime)}
            <span className="eth-tx-time-sep">|</span>
            {formatUtcTimestamp(display.blockTime)}
          </div>
        </div>

        <div className="eth-tx-row">
          <div className="eth-tx-row__label">Transactions:</div>
          <div className="eth-tx-row__value">{display.transactionCount?.toLocaleString()}</div>
        </div>
      </section>

      {display.transactions?.length > 0 ? (
        <section className="eth-tx-card">
          <h2 className="stx-card-heading">Transactions</h2>
          <div className="stx-block-tx-list">
            {display.transactions.map((tx) => (
              <Link
                key={tx.hash}
                to={`/tx/${encodeURIComponent(tx.hash)}`}
                className="stx-block-tx-item"
              >
                <code>{tx.displayHash}</code>
              </Link>
            ))}
          </div>
        </section>
      ) : null}
    </main>
  );
}

export default EvmBlockDetailsView;
